import i18n from 'i18next';
import { call, put } from 'redux-saga/effects';
import { changePasswordFailure, changePasswordSuccess } from '../actions';
import { changePassword } from '../api';
import { ChangePasswordRequestAction } from '../types';
import { ApiError, ApiResponse } from 'store/api/types';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { turnMessageOn, turnModalOff } from 'store/app/actions';
import { checkResponse } from 'store/utils';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* changePasswordSaga(action: ChangePasswordRequestAction) {
  try {
    let err: ApiError | null;

    const { oldPassword, newPassword } = action.payload;
    const response: ApiResponse = yield call(
      changePassword,
      oldPassword,
      newPassword
    );

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    const message: MessageData = {
      title: i18n.t('notifications.updated'),
      description: i18n.t('notifications.password-changed-successfully'),
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));
    yield put(changePasswordSuccess());
    yield put(turnModalOff());
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(changePasswordFailure());
  }
}
